import { forwardRef, useId, type InputHTMLAttributes, type ReactNode } from 'react';

export interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  label?: string;
  error?: string;
  hint?: ReactNode;
  /** Máscara aplicada a cada digitação (ver utils/masks). */
  mask?: (v: string) => string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  addon?: ReactNode;
}

/** Campo de texto com rótulo, máscara, dica e erro (C-09). Compatível com react-hook-form (register). */
const TextField = forwardRef<HTMLInputElement, TextFieldProps>(function TextField({ label, error, hint, mask, onChange, addon, id, className = '', ...rest }, ref) {
  const autoId = useId();
  const fieldId = id ?? autoId;
  return (
    <div className={`field ${className}`}>
      {label && <label htmlFor={fieldId}>{label}</label>}
      <div className="input-wrap">
        <input
          ref={ref}
          id={fieldId}
          className="input"
          aria-invalid={!!error || undefined}
          aria-describedby={error ? `${fieldId}-err` : undefined}
          onChange={(e) => {
            if (mask) e.target.value = mask(e.target.value);
            onChange?.(e);
          }}
          {...rest}
        />
        {addon && <span className="addon">{addon}</span>}
      </div>
      {error ? <span className="error" id={`${fieldId}-err`}>{error}</span> : hint ? <span className="hint">{hint}</span> : null}
    </div>
  );
});
export default TextField;
